import React, { useState } from 'react'
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '../../Modal/Modal'
import Button from "../../Button/Button";
import ButtonGroup from "../../Button/ButtonGroup/ButtonGroup";
import SelectImage from './SelectImage/SelectImage'
import '../style.css'
import { Asset, ChooseAssetModalProps } from '../types';

export const getImageMarkdown = (href, text = 'Enter your image caption here') => {
  text = text === '' ? href : text
  return `![${text}](${href})`
}

declare global {
  interface Window {
    extension_uid: any;
  }
}
interface IModalComponentState {
  assets: Asset[]
}

const ModalComponent = (props: ChooseAssetModalProps) => {
  const isMultiple = props?.multiple
  const [state, setState] = useState<IModalComponentState>({
    assets: [],
  });

  const setAssets = (assets) => {
    setState(state => ({
      ...state,
      assets: assets.map((asset) => ({
        ...asset,
        // these duplicated camel-cased keys are for backward compatibility
        fileName: asset.filename,
        fileSize: asset.file_size,
        contentType: asset.content_type,
      })),
    }))
  }

  const handleSubmit = () => {
    if (props.onSubmit) {
      props.onSubmit(state.assets)
    }
    handleReset()
  }

  const handleRestoreWithoutAssets = () => {
    if (props.handleRestoreWithoutAssets) {
      props.handleRestoreWithoutAssets()
    }
    handleReset()
  }

  const handleRestoreWithAssets = () => {
    if (props.handleRestoreWithAssets) {
      props.handleRestoreWithAssets()
    }
    handleReset()
  }

  const handleReset = () => {
    props.closeModal()
  }

  const isAssetSelected = !state.assets.length;

  return (
    <div className="asset-picker">
      <div id="scrte-image-modal">
        <ModalHeader title={props?.modalTitle ? props.modalTitle : 'Select Asset'} closeModal={props.closeModal} />

        <ModalBody className="modalBodyCustomClass">
          <SelectImage
            setImages={setAssets}
            only={props?.only}
            fileTypes={props.fileTypes}
            minSize={props?.size?.min}
            maxSize={props?.size?.max}
            excludeAssetUids={props?.excludeAssetUids}
            getAssets={props?.getAssets}
            getUsers={props?.getUsers}
            vendor={props?.vendor || ''}
            showUserDataColumn={'showUserDataColumn' in props ? props.showUserDataColumn : true}
            showCTAIcon={props?.showCTAIcon}
            multiBranchInfo={props?.multiBranchInfo || ''}
            hasBranchFeature={props?.hasBranchFeature || false}
            isFolderSelection={props?.isFolderSelection || false}
            displayType={props?.displayType}
            onDisplayTypeChange={props?.onDisplayTypeChange}
            initiallySelectedAssets={props?.initiallySelectedAssets}
            viewOnly={props?.viewOnly}
            {...(isMultiple && { multiple: props.multiple })} />
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button onClick={handleReset} buttonType="light">
              Cancel
            </Button>
            {!props?.viewOnly && (
            <Button data-testid="add-asset" onClick={handleSubmit}
              disabled={isAssetSelected}
              {...(props?.showCTAIcon && { icon: 'CheckedWhite' })}
              >
              {props?.modalApplyButtonText ? props.modalApplyButtonText : 'Add Selected Asset'}
            </Button>
            )}
            {props?.fromTrashPage && (
              <>
              <Button onClick={handleRestoreWithoutAssets} buttonType="secondary">
                Restore Without Assets
              </Button>
              <Button onClick={handleRestoreWithAssets} buttonType="primary">
                Restore With Assets
              </Button>
              </>
            )}
          </ButtonGroup>
        </ModalFooter>
      </div>
    </div>
  )
}
export default ModalComponent